module.exports = __webpack_public_path__ + "img/e352c4d1e1343614b49d7f711075c7c8aec53b08.aebc0508.png";